import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { StatusIndicatorPriorityComponent } from './priority/status-indicator-priority.component';
import { StatusIndicatorStepComponent } from './step/status-indicator-step.component';
import { StatusIndicatorComponent } from './status-indicator.component';

const COMPONENTS = [StatusIndicatorPriorityComponent, StatusIndicatorStepComponent, StatusIndicatorComponent];

@NgModule({
  imports: [CommonModule, NgbTooltipModule],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class StatusIndicatorModule {}
